import React from "react";

/**
 * SEO — uses React 19's native metadata hoisting.
 * Just render <title> / <meta> / <link> / <script type="application/ld+json"> from anywhere
 * and React lifts them into <head>.
 */
const ORIGIN = "https://zelaflo.com";
const DEFAULT_OG_IMAGE = "https://customer-assets.emergentagent.com/job_workflow-builder-125/artifacts/y4lualkn_Zelaflo%20Logo.svg";

export const SEO = ({ title, description, path = "/", image = DEFAULT_OG_IMAGE, jsonLd }) => {
  const url = `${ORIGIN}${path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Zelaflo Labs" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </>
  );
};

export default SEO;
